module.exports = __webpack_public_path__ + "static/img/fl5.cb5d749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/safes/fl5.png
// module id = Ra/M
// module chunks = 0